import BaseComponent from "./BaseComponent";

export default class MultiselectComponent extends BaseComponent
{
    constructor()
    {
        super();

        $('select.blb-input[multiple="multiple"]').select2({
            width: 'element',
            adaptContainerCssClass: function( cl ) {
                if( cl == 'blb-input-error' ) return cl;
            },
        });
    }
}